/*
import '@fontsource/anton';
import '@fontsource/karla';
import '@fontsource/poppins/400.css';
import '@fontsource/poppins/500.css';
'R&C-BasicLight'
'R&C-BasicFull'
'R&C-BasicEmpty'
'R&C-GuidelinesEmpty'
'R&C-GuidelinesDark'
'R&C-GuidelinesLight'
'R&C-GuidelinesFull'
'R&C-BasicDark'
*/

// # TODO => simplify this
export const fontFamily = {
    anton: `'Anton', sans-serif`,
    poppins: `'Poppins', sans-serif`,
    karla: `'karla', sans-serif`,

    rc: {
        basicLight: '"R&C-BasicLight"',
        basicFull: '"R&C-BasicFull"',
        basicEmpty: '"R&C-BasicEmpty"',
        guidelinesEmpty: '"R&C-GuidelinesEmpty"',
        guidelinesDark: '"R&C-GuidelinesDark"',
        guidelinesLight: '"R&C-GuidelinesLight"',
        guidelinesFull: '"R&C-GuidelinesFull"',
        basicDark: '"R&C-BasicDark"',
    },
};
